import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'
import {useCallback} from 'react'
import {OVERVIEW_COMMENTS_ANCHOR_ID} from '../../helpers/constants'

export function useScrollToComments() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return useCallback(() => {
    const commentsSection = document.getElementById(OVERVIEW_COMMENTS_ANCHOR_ID)
    if (!commentsSection) return

    commentsSection.scrollIntoView({behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start'})
    commentsSection.focus({preventScroll: true})
  }, [prefersReducedMotion])
}
